import Breadcrumb from '@/components/feature/Breadcrumb';

export default function CalendarHeader() {
  return (
    <section className="bg-primary-500 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '追漫日历' }]} />
        <h1 className="mt-4 font-heading text-3xl text-background-50 md:text-4xl">追漫日历</h1>
        <p className="mt-3 max-w-2xl text-primary-50 md:text-lg">
          一周连载更新日程一览，每部作品的更新日期、时间与最新话数都清清楚楚，安排你的追更节奏。
        </p>
      </div>
    </section>
  );
}